<template>
  <div class="items-container">
   
	<div class="column v-center center mb-xxl">
	    <div class="row">
	        <div class="ml-xxl  h1" style=" color: #ff3355;">
	           互动游戏
	        </div>
	      <div class="relative ml-md" style="width:84px; height:84px;">
	          <img :src="PlusRedIcon" style="width:84px; height:84px; position:absolute; top:-40px; left:-30px;" />
	      </div>
	    </div>
	  <!--  <div class="t3" style="text-transform: uppercase; letter-spacing:.1em; opacity:.5;">
	        Hardware facilities
	    </div> -->
	</div>
	
    <div class="items-grid">
      <div 
        v-for="(item, index) in items" 
        :key="index" 
        class="item-card"
        @click="selectItem(item)"
      >
        <div class="item-image-container">
          <img :src="item.image" :alt="item.title" class="item-image">
          <div class="image-overlay"></div>
        </div>
        <div class="item-content">
          <h3 class="item-title">{{ item.title }}</h3>
          <p class="item-description">{{ item.description }}</p>
        </div>
      </div>
    </div>
    
    <!-- 选中的项目详情模态框 -->
    <div v-if="selectedItem" class="modal-overlay" @click="selectedItem = null">
      <div class="modal-content" @click.stop>
        <button class="close-button" @click="selectedItem = null">×</button>
        <img :src="selectedItem.image" :alt="selectedItem.title" class="modal-image">
        <div class="modal-details">
          <h2>{{ selectedItem.title }}</h2>
          <p>{{ selectedItem.description }}</p>
          <p class="modal-full-description">{{ selectedItem.fullDescription }}</p>
        </div>
      </div>
    </div>
 <div class="item-content1">
    <span class="item-title1" @click="onClick()">立即体验>></span>
 </div>
  </div>
</template>

<script>
	import {
	    IconPrev,
		PlusRedIcon,
	    IconNext,
	    PlusWhiteIcon,
	    Arrow,
	    Circle,
	    game0,game1,game2,game3,game4,game5,game6,game7,game8,game10,game11,game12,game13,game14,game15,game16,game17,game18,game19,game20,game21,game22,
	    Hardware03,
	    Hardware04,
	    Hardware07,
	} from '@/constants/pics';
export default {
  name: 'ItemsGrid',
  data() {
    return {
      selectedItem: null,
	  PlusRedIcon,
      items: [
		  {
		    title: '电子请柬',
		    description: '转发设置好的活动，直接可以当电子请柬使用！',
		    fullDescription: '',
		    image: game19},
		  {
		    title: '签名',
		    description: '宾客通过手机亲笔签名，汇聚成签名墙，为新人婚礼见证！。、',
		    fullDescription: '',
		    image: game2},
		  {
		    title: '冠名祝福',
		    description: '宾客趣味填词，冠名成语，表达对新人的祝福！满屏的祝福',
		    fullDescription: '',
		    image: game3},
			{
			  title: '精彩时刻',
			  description: '宾客上传或拍摄婚礼美好瞬间，汇聚成照片墙，保存婚礼珍贵记忆！',
			  fullDescription: '',
			  image: game1  },
			  {
			    title: '造型拍',
			    description: '宾客照图摆造型拍照，留存温馨画面！',
			    fullDescription: '',
			    image: game5},
				{
				  title: '留言',
				  description: '可给新人/负责人留言，给彼此一个表达心意的空间',
				  fullDescription: '',
				  image: game22},
				{
				  title: '活跃榜',
				  description: '宾客参与相应活动，系统给予对应活跃度，根据活跃度排名，方便主持人选出全场最活跃宾客。',
				  fullDescription: '',
				  image: game17
				},
       {
         title: '红包雨',
         description: '点赞红包雨：宾客集体点赞到一定数量，会触发设定的答谢红包雨\n宾客红包雨：宾客可以大屏红包雨形式发给现场所有人。',
         fullDescription: '',
         image: game0
       },
	   {
	     title: '照片霸屏',
	     description: '宾客可把拍的有趣照片，霸屏',
	     fullDescription: '',
	     image: game18
	   },
	   {
	     title: '幸运抽奖',
	     description: '大屏滚动头像，心跳倒计时，最终抽取幸运儿。是活动必备环节，轻松将现场气氛推向高潮。',
	     fullDescription: '',
	     image: game11 },
       {
         title: '数钞票',
         description: '参与者滑动手机上的钞票，比赛谁数的又多又快，是暖场和团队比拼的绝佳选择.',
         fullDescription: '',
         image: game7},
		 
		  {
		    title: '摇一摇（赛车）',
		    description: '参与者疯狂摇动手机，驱动屏幕上的赛車飞驰，是暖场和团队比拼的绝佳选择',
		    fullDescription: '',
		    image: game16} ,
			
			  {
			    title: '诗词歌赋',
			    description: '围绕古典诗词、文学常识进行问答竞赛，文雅而不失趣味，考验文化底蕴。',
			    fullDescription: '',
			    image: game13},
			    {
			      title: '看图猜人',
			      description: '展示人物局部特征,竞猜明星',
			      fullDescription: '',
			      image: game12},
			  {
			    title: '神奇的汉字',
			    description: '给定两至三个偏旁部首，参与者组合拼成一个完整的汉字，巧妙展现中华文字的博大精深。',
			    fullDescription: '',
			    image: game14},
			  {
			    title: '趣味猜成语',
			    description: '每张精美图片代表一个汉字，组合多张图片的含义，最终猜出一个完整成语',
			    fullDescription: '',
			    image: game15},
      
        {
          title: '看图猜成语',
          description: '用一张图画概括一个成语，考验观察力与想象力，趣味横生',
          fullDescription: '',
          image: game4 },
        
       {
         title: '听歌识曲',
         description: '播放经典或热门歌曲的片段，参与者抢先猜出歌名，是调动全场记忆与热情的经典游戏。',
         fullDescription: '',
         image: game10 },
       
        {
          title: '麻雀大赛',
          description: '展示一副麻将牌局，玩家需推理听什么牌才能胡牌，深受麻将爱好者喜爱。',
          fullDescription: '',
          image: game8},
      {
        title: '台词秀',
        description: '播放经典影视片段，参与者抢答接出下一句台词，是引发共鸣的欢乐舞台',
        fullDescription: '',
        image: game6},
		{
		  title: '看字说颜色',
		  description: '参与者需要忽略文字本身的意义，快速说出这个文字的颜色，你的反应力与直觉的终极挑战！',
		  fullDescription: '',
		  image: game20},
		  {
		    title: '谐音梗',
		    description: '屏幕上显示一张趣味图片，参与者猜出一个与之匹配的“梗”',
		    fullDescription: '',
		    image: game21}

      ]
    }
  },
  methods: {
	  onClick(){
	  window.location.replace('https://admin.xiliji.tech/app/admin')
  },
    selectItem(item) {
      this.selectedItem = item;
    }
  }
}
</script>

<style scoped>
.items-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.page-title {
  text-align: center;
  margin-bottom: 30px;
 color: #ff3355;
  font-weight: 600;
  font-size: 2.2rem;
}

.items-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
}

.item-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.item-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.15);
}

.item-image-container {
  position: relative;
  height: 180px;
  overflow: hidden;
}

.item-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.item-card:hover .item-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.4));
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.item-card:hover .image-overlay {
  opacity: 0.9;
}

.item-content {
  padding: 18px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
    justify-content: center;
}
.item-content1 {
  padding: 18px;
  flex-grow: 1;
  display: flex;
 
    justify-content: center;
}
.item-title {
	cursor: pointer;
  margin: 0 0 10px 0;
  font-size: 1.2rem;
  color: #ff3355;
  font-weight: 600;
  line-height: 1.3;
}
.item-title1 {
	cursor: pointer;
  margin: 0 0 10px 0;
  font-size: 1.4rem;
  color: #ff3355;
  font-weight: 600;
  line-height: 1.3;
}

.item-description {
  margin: 0;
  color: #7f8c8d;
  font-size: 0.9rem;
  line-height: 1.5;
  flex-grow: 1;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background: white;
  border-radius: 16px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: slideUp 0.4s ease;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.2s ease;
}

.close-button:hover {
  background: white;
}

.modal-image {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

.modal-details {
  padding: 25px;
}

.modal-details h2 {
  margin-top: 0;
  color: #2c3e50;
  font-size: 1.8rem;
}

.modal-details p {
  color: #555;
  line-height: 1.6;
}

.modal-full-description {
  margin-top: 15px;
  font-size: 1rem;
  color: #34495e;
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(30px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .items-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .items-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .modal-content {
    flex-direction: column;
  }
  
  .modal-image {
    height: 250px;
  }
}

@media (max-width: 480px) {
  .items-grid {
    grid-template-columns: 1fr;
  }
  
  .page-title {
    font-size: 1.8rem;
  }
  
  .modal-details {
    padding: 20px;
  }
  
  .modal-details h2 {
    font-size: 1.5rem;
  }
}
</style>